import consumer from '../channels/consumer'
import CableReady from 'cable_ready'

// Configure CableReady
CableReady.initialize({ consumer })

// Store original perform method before overriding
const originalPerform = CableReady.perform

// Override perform method to add DOM element checking and error handling
CableReady.perform = function(operations) {
  try {
    // Handle both single operation and array of operations
    const opsArray = Array.isArray(operations) ? operations : [operations]

    // Filter operations to only include those with existing elements
    const validOps = opsArray.filter(op => {
      // Skip filtering for operations that don't require DOM elements
      if (!op || !op.selector) {
        return true
      }

      // Allow 'remove' operations even if element doesn't exist
      if (op.name === 'remove' || op.operation === 'remove') {
        return true
      }

      // Check if the target element exists
      const exists = !!document.querySelector(op.selector)
      if (!exists) {
        console.debug(`[CableReady] Skipping ${op.name || op.operation} for missing element: ${op.selector}`)
        return false
      }

      return true
    })

    // If no valid operations remain, skip execution
    if (validOps.length === 0) {
      console.debug('[CableReady] No valid operations to perform after filtering')
      return
    }

    // Call original perform with filtered operations
    // Restore array/single format based on original input
    const opsToPerform = Array.isArray(operations) ? validOps : validOps[0]
    return originalPerform.call(this, opsToPerform)

  } catch (error) {
    console.error('[CableReady] Error during perform:', error)
    // Don't throw - allow app to continue running
  }
}
